import {createContext, ReactNode, useContext} from 'react';

type ViewModelContextType = {};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  return (
    <ViewModelContext.Provider value={{}}>{children}</ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error('AddKid ViewModelContext is undefined');
  }
  return context;
}
